import { BaseReq, BaseResp } from "@/core/interface";
import { getCurrentTenantId, getCurrentUserId } from "@/utils";

export enum TabEnum {
  INVALID_TAB = "INVALID_TAB",
  TENANT_TAB = "TENANT_TAB",
  VALID_MOBILE_TAB = "VALID_MOBILE_TAB",
  SET_PWD_TAB = "SET_PWD_TAB",
}

export class SetPwdReq {
  inviteSignature: string = ""; // 邀请签名
  mobile: string = ""; // 手机号
  password: string = ""; // 用户输入密码
  verificationCode?: string = ""; // 验证码 dev.fat环境返回,pro禁用
}

export class TenantInfo extends BaseReq {
  address: string = ""; // 租户企业地址
  authStatus: number | undefined = undefined; // 租户认证状态 1:已认证 0:未认证
  company: string = ""; // 租户企业名称
  mobile: string = ""; // 租户用户手机号
  realName: string = ""; // 租户用户真实姓名
  userId: string = ""; // 用户 ID
  tenantId: string = ""; // 租户 ID
  tenantUserId: string = ""; // 租户用户 ID
  verificationCode:string='';
}
export class ChangePwdReq {
  mobile: string = "";
  oldPassword: string = "";
  newPassword: string = "";
  confirmNewPassword: string = "";
  verifyCode: string = "";
}
export interface loginVerifySignatureRes{
  loginVerifySignature: string | undefined;
}
export class FeedbackReq {
  name: string = "";
  mobile: string = "";
  content: string = "";
  tab: string = "PC";
  title: string = "反馈意见和建议";
  tenantUserId: string = getCurrentUserId();
  tenantId: string = getCurrentTenantId();
}
